import { render } from "./ProjectWorkList.vue?vue&type=template&id=baf1f05c&scoped=true"
import script from "./ProjectWorkList.vue?vue&type=script&lang=ts"
export * from "./ProjectWorkList.vue?vue&type=script&lang=ts"

import "./ProjectWorkList.vue?vue&type=style&index=0&id=baf1f05c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-baf1f05c"

export default script